import { render, staticRenderFns } from "./CheckBoxTable.vue?vue&type=template&id=6377464d&"
import script from "./CheckBoxTable.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports